import React, {useState, useEffect} from 'react'

import classes from './ActivityDebrief.module.css'
import ActivityPedaInstance from 'react-sdk/activities/ActivityPedaInstance';

/**
 *
 * @param {object} props
 * @param {ActivityPedaInstance} props.instance
 * @returns
 */
const ActivityDebrief = ({instance}) => {

  return (
    <div
    className={classes.ActivityDebrief}
    dangerouslySetInnerHTML={{__html: instance.getDebrief()?.Text}} />
  );
};

export default ActivityDebrief;
